import { ButtonAttractive, ButtonIcon, ButtonType } from '../button/button.component';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';

import { BaseComponent } from '../base/base-component.component';

export enum DialogSize {
  Small = 0,
  Large = 1,
  FullScreen = 2,
}

export enum DialogBehavior {
  Regular = 0,
  DesktopMobile = 1,
}

@Component({
  standalone: false,
  selector: 'daui-dialog',
  templateUrl: './dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./dialog.component.less'],
})
export class DialogComponent extends BaseComponent {
  @Input() isShow = false;
  @HostBinding('class.show') showStyle = false;

  @Input() size: DialogSize = DialogSize.Small;
  @Input() behavior: DialogBehavior = DialogBehavior.Regular;
  @Output() exitFullScreenOrEsc: EventEmitter<void> = new EventEmitter<void>();

  dialogSize = DialogSize;
  dialogBehavior = DialogBehavior;

  readonly buttonType = ButtonType;
  readonly buttonAttractive = ButtonAttractive;
  readonly buttonIcon = ButtonIcon;

  @HostListener('document:keyup.escape') onKeydownHandler() {
    this.onExit();
  }

  constructor(readonly element: ElementRef) {
    super();
  }

  onInit() {}
  onDestroy() {}

  ngOnChanges() {
    this.showStyle = this.isShow;
  }
  onExit() {
    this.exitFullScreenOrEsc.emit();
  }
}
